import React, { useState } from "react";
import Footer from "../components/Footer";
import SAND from "../assets/images/sand.png";
import TOKEN from "../assets/images/token.png";
import COINSANDARROW from "../assets/images/coin-sand-arrow.png";
import ARROW from "../assets/images/arrow-right.png";
import Header from "../components/Header";
import Icon from "../components/icons/Icon";
import Contact from "./Contact";
import OptionModal from "../components/OptionsModal";

export const Token = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="flex flex-col w-full ">
      <div
        className="flex flex-col  p-3  justify-center items-center bg-[#081533] lg:min-w-[1024px]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 10%, rgba(21, 83, 224, 1) 5%, rgba(8, 21, 51, 0.8) 40%, rgba(8, 21, 51, 0.5) 80%), radial-gradient(circle at 30% 50%, rgba(21, 83, 224, 0.6) 10%, rgba(8, 21, 51, 0.8) 50%, rgba(8, 21, 51, 0.3) 80%), radial-gradient(circle at 70% 70%, rgba(21, 83, 224, 0.7) 10%, rgba(8, 21, 51, 0.8) 50%, rgba(8, 21, 51, 0.4) 80%)",
          position: "relative",
        }}
      >
        <Header />

        <div className="flex flex-col h-fit  p-3  lg:w-[1400px] items-center justify-between mt-1 lg:mt-5">
          <div className="text-center items-center justify-center text-white w-full">
            <div className="m-6 p-3">
              <h2 className="text-5xl text-center mt-1 lg:mt-4 py-2 font-bold">
                Transforme ativos reais em oportunidades digitais
              </h2>
            </div>
            <div className="m-6 p-3 ">
              <p className="text-lg  text-white/90  text-center">
                A Wii Ascend oferece a possibilidade de tokenizar seus ativos,
                trazendo
                <br /> inovação e segurança para o seu portfólio.{" "}
                <span className="font-semibold text-white">
                  Converta propriedades, investimentos
                  <br /> e bens valiosos em tokens digitais, acessíveis e
                  negociáveis no mundo da blockchain.
                </span>
              </p>
            </div>
          </div>

          <div className="flex flex-row w-fit h-[400px] items-center justify-between">
            <div className="hidden lg:block mr-8  w-fit h-fit items-center">
              <img
                src={TOKEN}
                alt="Tokenization"
                className="w-[300px] h-[300px] rounded-xl"
              />
            </div>

            <div className="flex flex-col w-auto h-auto items-center justify-center">
              <div className="flex flex-row gap-6 justify-center mb-20">
                <button className="bg-white w-44 text-black py-2 px-6 rounded-full hover:bg-[#7A5F22]">
                  <a
                    href="https://www.linkedin.com/company/wiiascend/posts/?feedView=all"
                    target="_blank"
                    className="text-black rounded-full"
                  >
                    Saiba mais
                  </a>
                </button>
              </div>
              <div className="block lg:hidden  h-auto w-full flex flex-row items-center justify-center">
                <img
                  src={COINSANDARROW}
                  alt="COINSANDARROW"
                  className="w-full h-[200px] rounded-xl"
                />
              </div>

              <div className="hidden lg:block  flex w-auto h-auto gap-6 mb-10 items-center justify-center">
                <img
                  src={ARROW}
                  alt="Blockchain"
                  className="w-[100px] h-[100px] justify-center rounded-xl"
                />
              </div>
            </div>

            <div className="hidden lg:block ml-8   flex w-fit h-fit">
              <img
                src={SAND}
                alt="Sand"
                className="w-[330px] h-[330px] rounded-xl"
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col w-fit lg:w-[900px] items-center p-20">
          <div className="text-center text-white mb-12">
            <h2 className="text-5xl font-bold mb-6">
              Segurança e flexibilidade para seus ativos tokenizados
            </h2>
            <p className="text-lg lg:ml-8 lg:mr-8 text-white/90 mb-12 text-center">
              Na Wii Ascend, utilizamos as melhores práticas de segurança, como
              <br />
              criptografia de ponta e autenticação em dois fatores, para
              garantir que seus
              <br />
              ativos tokenizados estejam sempre protegidos.{" "}
              <span className="font-semibold text-white">
                Além disso, a plataforma
                <br />
                oferece flexibilidade, permitindo a negociação e transferência
                de
                <br />
                frações de ativos de forma simples e segura.
              </span>
            </p>
          </div>

          <div className="flex flex-col items-center justify-center gap-4 mb-12 w-fit">
            <div className="flex flex-col lg:flex-row gap-4 justify-center items-center">
              <div className="flex flex-row items-center justify-center bg-[#FAFAFA]/5 text-white  text-center p-6 rounded-xl w-[300px] h-[150px]">
                <h3 className="text-xl text-white/90 ">Criptografia AES-256</h3>
              </div>
              <div className="flex flex-row items-center justify-center bg-[#FAFAFA]/5  text-center text-white p-6 rounded-xl w-[300px] h-[150px]">
                <h3 className="text-xl text-white/90">
                  Autenticação em dois fatores (2FA)
                </h3>
              </div>
              <div className="flex flex-row items-center justify-center bg-[#FAFAFA]/5 text-center text-white p-6 rounded-xl w-[300px] h-[150px]">
                <h3 className="text-xl text-white/90">Monitoramento 24/7</h3>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-4 justify-center items-center">
              <div className="flex flex-row items-center justify-center bg-[#FAFAFA]/5 text-center text-white p-6 rounded-xl w-[300px] h-[150px]">
                <h3 className="text-xl text-white/90">
                  Compliance com LGPD, GDPR, KYC e AML
                </h3>
              </div>
              <div className="flex flex-row items-center justify-center bg-[#FAFAFA]/5 text-white text-center p-6 rounded-xl w-[300px] h-[150px]">
                <h3 className="text-xl text-white/90">
                  Acesso rápido a mercados digitais com total controle
                </h3>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-6 justify-center">
            <button
              onClick={openModal}
              className="bg-[#0E2D60] text-white py-2 px-6 rounded-full border border-gray-100 hover:bg-[#1553E0]"
            >
              Comece agora
            </button>
            <button className="bg-white text-black py-2 px-6 rounded-full hover:bg-[#7A5F22]">
              <a
                href="https://wa.me/5555489108142"
                target="_blank"
                className="text-black "
              >
                Fale com um especialista
              </a>
            </button>
          </div>
        </div>
      </div>

      <div className="flex bg-white items-center justify-center">
        <div className="flex flex-col  w-[900px] justify-center items-center p-10">
          <div className="text-start mb-12">
            <h2 className="text-center text-[#887443] text-4xl font-bold mb-6">
              Invista no futuro com segurança e inteligência
            </h2>
            <p className="text-lg text-center text-[#1E1E1E]">
              Nossa plataforma proporciona rentabilidade, diversificação e
              proteção
              <br />
              do seu patrimônio com soluções inovadoras e seguras.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-2 mb-12 w-full">
            <div className="bg-[#887443]/10 justify-center text-center text-white p-6 rounded-xl  border border-[#88744366]/40 flex flex-col items-center">
              <div className="bg-[#887443] text-white items-center justify-center rounded-full">
                <Icon name="MoneyBarras" className="text-white w-8 h-8 m-3" />
              </div>
              <h3 className="text-xl text-black  mb-4">
                Acesso a novos mercados de <br />
                investimento
              </h3>
            </div>

            <div className="bg-[#887443]/10 justify-center text-center text-white p-6 rounded-xl flex flex-col border border-[#88744366]/40 items-center">
              <div className="bg-[#887443] text-white items-center justify-center rounded-full">
                <Icon name="MoneyCoin" className="text-white w-8 h-8 m-3" />
              </div>
              <h3 className="text-xl text-black  mb-4">
                Maior liquidez e <br />
                transações rápidas
              </h3>
            </div>

            <div className="bg-[#887443]/10 justify-center text-center text-white p-6 rounded-xl flex flex-col border border-[#88744366]/40 items-center">
              <div className="bg-[#887443] text-white items-center justify-center rounded-full">
                <Icon name="MoneyGotas" className="text-white w-8 h-8 m-3" />
              </div>
              <h3 className="text-xl text-black  mb-4">
                Tokenização de ativos valiosos (imóveis, arte, etc.)
              </h3>
            </div>

            <div className="bg-[#887443]/10 justify-center text-center text-white p-6 rounded-xl flex flex-col border border-[#88744366]/40 items-center">
              <div className="bg-[#887443] text-white items-center justify-center rounded-full">
                <Icon name="MoneyCubo" className="text-white w-8 h-8 m-3" />
              </div>
              <h3 className="text-xl text-black  mb-4">
                Controle total e transparência com blockchain
              </h3>
            </div>

            <div className="bg-[#887443]/10 justify-center text-center text-white p-6 rounded-xl flex flex-col border border-[#88744366]/40 items-center">
              <div className="bg-[#887443] text-white items-center justify-center rounded-full">
                <Icon name="People" className="text-white w-8 h-8 m-3" />
              </div>
              <h3 className="text-xl text-black  mb-4">
                Soluções flexíveis para investidores de todos os níveis
              </h3>
            </div>

            <div className="bg-[#887443]/10 justify-center text-center text-white p-6 rounded-xl flex flex-col  border border-[#88744366]/40 items-center">
              <div className="bg-[#887443] text-white  items-center justify-center rounded-full">
                <Icon name="Shield" className="text-white w-8 h-8 m-3" />
              </div>
              <h3 className="text-xl text-black  mb-4">
                Segurança e transparência com respaldo da ANBIMA
              </h3>
            </div>
          </div>
        </div>
      </div>
      <Footer />
        <OptionModal isOpen={isModalOpen} closeModal={closeModal} />
    </div>
  );
};
